import React from 'react';

const InfoBorder = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none">
      <g fill="#3FB0E8">
        <path d="M12 0c3.205 0 6.219 1.248 8.485 3.515C22.752 5.78 24 8.795 24 12c0 3.205-1.248 6.219-3.515 8.485C18.22 22.752 15.205 24 12 24c-3.205 0-6.219-1.248-8.485-3.515C1.248 18.22 0 15.205 0 12c0-3.205 1.248-6.219 3.515-8.485C5.78 1.248 8.795 0 12 0zm0 1.47c-2.813 0-5.457 1.095-7.446 3.084C2.564 6.543 1.469 9.187 1.469 12c0 2.813 1.096 5.457 3.085 7.446 1.989 1.99 4.633 3.085 7.446 3.085 2.813 0 5.457-1.096 7.446-3.085 1.99-1.989 3.085-4.633 3.085-7.446 0-2.813-1.096-5.457-3.085-7.446-1.989-1.99-4.633-3.085-7.446-3.085zm.98 9.53v7.424h-1.96V11h1.96zm0-4.417v1.96h-1.96v-1.96h1.96z"/>
      </g>
    </g>
  </svg>
 /* <svg width="46" height="46" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <rect stroke="#EF7800" stroke-width="2" x="1" y="1" width="44" height="44" rx="22"/>
      <g fill="#EF7800">
        <path d="M24.028 33.583V16.512a1.014 1.014 0 1 0-2.028 0v17.071a1.014 1.014 0 1 0 2.028 0zM23.014 11.028a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5z"/>
      </g>
    </g>
  </svg>*/


)

export default InfoBorder